import { getDefaultExportFromCjs as c, commonjsGlobal as i } from "./index61.js";
import { __exports as l } from "./index75.js";
import "./index76.js";
import "./index77.js";
import "./index78.js";
import "./index79.js";
import { __exports as d } from "./index80.js";
import { __exports as b } from "./index81.js";
import { __exports as p } from "./index82.js";
import { __exports as T } from "./index83.js";
(function(e) {
  var a = i && i.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = s;
  var u = a(d);
  e.htmlToDOM = u.default;
  var f = a(b);
  e.attributesToProps = f.default;
  var m = a(p);
  e.domToReact = m.default;
  var r = T;
  Object.defineProperty(e, "Comment", { enumerable: !0, get: function() {
    return r.Comment;
  } }), Object.defineProperty(e, "Element", { enumerable: !0, get: function() {
    return r.Element;
  } }), Object.defineProperty(e, "ProcessingInstruction", { enumerable: !0, get: function() {
    return r.ProcessingInstruction;
  } }), Object.defineProperty(e, "Text", { enumerable: !0, get: function() {
    return r.Text;
  } });
  var _ = { lowerCaseAttributeNames: !1 };
  function s(t, o) {
    var n;
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    return t ? (0, m.default)((0, u.default)(t, (n = o == null ? void 0 : o.htmlparser2) !== null && n !== void 0 ? n : _), o) : [];
  }
})(l);
const E = /* @__PURE__ */ c(l);
export {
  E as default
};
